import { ActionTypeKeys, ActionTypes } from 'common/actions'

export interface AuthState {
  isLoggedIn: boolean
}

export const initialAuthState: AuthState = {
  isLoggedIn: false,
}

const reducer = (state: AuthState = initialAuthState, action: ActionTypes) => {
  switch (action.type) {
    case ActionTypeKeys.CREATE_ACCOUNT_SUCCESS:
      return { ...state, isLoggedIn: true }
    default:
      return state
  }
}

export default reducer
